'use strict';

jQuery(document).on('gform_post_render', () => {
    const selectBtnText = {
        1: "Select files",
        2: "Atlasiet failus",
        3: "Pasirinkite failus",
        4: "Valige failid",
        6: "Valitse tiedostot",
        7: "Select files",
    };

    jQuery('.gform_button_select_files').html(selectBtnText[site.site_id]);

    jQuery('.gfield_select').select2({
        dropdownParent: '.ginput_container_select'
    });

    gform.addFilter('gform_file_upload_markup', function (html, file, up, strings, imagesUrl) {
        var formId = up.settings.multipart_params.form_id,
            fieldId = up.settings.multipart_params.field_id;
            html = '<strong>' + file.name + "</strong> <img class='gform_delete' "
            + "src='" + imagesUrl + "/delete.png' "
            + "onclick='gformDeleteUploadedFile(" + formId + "," + fieldId + ", this);' "
            + "alt='" + strings.delete_file + "' title='" + strings.delete_file + "' />";

        return html;
    });
});